import React from "react";

import { TablesManagement } from "features/TablesManagement";
import { PageTitle } from "shared/ui";

const TablesManagementPage = () => {
    return (
        <>
            <PageTitle>Столы</PageTitle>
            <TablesManagement />
        </>
    );
};

export default TablesManagementPage;
